import { render, staticRenderFns } from "./Cors.vue?vue&type=template&id=172bf010&lang=pug"
import script from "./Cors.vue?vue&type=script&lang=js"
export * from "./Cors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports